import Rx from 'rxjs';
import moment from 'moment';
import { push, goBack } from 'react-router-redux';

import { combineEpics } from 'redux-observable';

import * as constAction from 'root/actionConstants';
import * as viajesActions from 'modules/viajes/action';
import * as errorActions from 'modules/error/action';
import * as generalActions from 'modules/general/action';
import * as registrosActions from 'modules/registros/action';

import { request } from 'core/generalFunctions';
import { minCronGet } from 'core/constants';

const { ajax } = Rx.Observable;

var cronGetViajesInterval = false;

export const getEpic = (action$, store) =>
  action$.ofType(constAction.VIAJES_GET).switchMap((action) =>
    ajax(request(action))
      .map(({ response }) =>
        viajesActions.setState({
          hoy: response.filter((viaje) => moment(viaje.horario).isSame(moment(), 'day')),
          manana: response.filter((viaje) => moment(viaje.horario).isSame(moment().add(1, 'day'), 'day')),
        }),
      )
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getByIdEpic = (action$, store) =>
  action$.ofType(constAction.VIAJES_GET_BY_ID).switchMap((action) =>
    ajax(request(action))
      .map((result) => viajesActions.setState({ viaje: result.response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const buscarEpic = (action$, store) =>
  action$.ofType(constAction.VIAJES_BUSCAR).switchMap((action) => {
    if (action.epic)
      return ajax(request(action))
        .map((result) => viajesActions.setState({ buscado: result.response }))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide()));
    else return Rx.Observable.empty();
  });

export const deleteEpic = (action$, store) =>
  action$
    .ofType(constAction.VIAJES_DELETE)
    .throttleTime(500)
    .switchMap((action) =>
      ajax(request(action))
        .mapTo(generalActions.snackbar_show('Viaje eliminado'))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.VIAJES_SET)
    .throttleTime(500)
    .switchMap((action) =>
      ajax(request(action))
        .mergeMap(() => {
          let actions = [viajesActions.buscar(new Date()), generalActions.snackbar_show(action.payload.viajeId ? 'Viaje modificado' : 'Viaje guardado')];
          if (!action.payload.viajeId) actions.push(goBack());
          if (action.onlyCreate) actions = [generalActions.snackbar_show(action.payload.viajeId ? 'Viaje modificado' : 'Viaje guardado')];
          action.payload.viajeId && actions.push(viajesActions.findUpdState(action.payload.viajeId, 'buscado', action.payload));
          return actions;
        })
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

function cronGetViajes(store) {
  store.dispatch(viajesActions.get());
  store.dispatch(registrosActions.get());
}

export const cronGetViajesEpic = (action$, store) =>
  action$.ofType(constAction.USER_ROLES_SET_STATE).mergeMap(() => {
    cronGetViajesInterval = setInterval(cronGetViajes, minCronGet, store);
    return Rx.Observable.empty();
  });

export const pasajerosSocketEpic = (action$, store) =>
  action$.ofType(constAction.VIAJES_SOCKET_DATA).switchMap((action) => {
    let viajeId = store.getState().getIn(['viajes', 'viaje', 'id']);
    if (action.payload.documentKey._id == viajeId) return Rx.Observable.of(viajesActions.getPasajeros(viajeId));
    return Rx.Observable.empty();
  });

export const getPasajerosEpic = (action$, store) =>
  action$.ofType(constAction.VIAJES_PASAJEROS_GET).switchMap((action) =>
    ajax(request(action))
      .map((result) => viajesActions.setAndOrderState(result.response))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getTrayectoEpic = (action$, store) =>
  action$.ofType(constAction.VIAJES_GET_TRAYECTO).switchMap((action) =>
    ajax(request(action))
      .map((result) => viajesActions.setTrayecto(result.response))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

//-- EPICS DE OTROS COMPONENTES --//
export const getParadasEpic = (action$, store) =>
  action$.ofType(constAction.VIAJES_PARADAS_GET).switchMap((action) =>
    ajax(request(action))
      .map((result) => viajesActions.setState({ paradas: result.response }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getTrayectoPointsEpic = (action$, store) =>
  action$.ofType(constAction.VIAJES_GET_TRAYECTOPOINTS).switchMap((action) =>
    ajax(request(action))
      .map(({ response }) => viajesActions.setState({ puntosDelTrayecto: response.map((points) => points.ubicacion) }))
      .catch((err) => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export default combineEpics(setEpic, getEpic, deleteEpic, buscarEpic, getByIdEpic, getParadasEpic, getTrayectoEpic, getPasajerosEpic, cronGetViajesEpic, pasajerosSocketEpic, getTrayectoPointsEpic);



// WEBPACK FOOTER //
// src/modules/viajes/epics.js